import { Tooltip, useTheme } from '@material-ui/core';
import { activeChatSideSelector } from '@src/selectors/chats';
import { ChatSideType, ChatTray } from '@src/types/chats';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { PinnedIcon } from './SvgIcons';
import IconWrapper from '../Common/IconWrapper';
import useChatPinned from './hooks/useChatPinned';

export type ChatPinnedIndicatorProps = {
  chat: ChatTray;
  isHovered?: boolean;
};

const ChatPinnedIndicator: React.FC<ChatPinnedIndicatorProps> = ({
  chat,
  isHovered = false,
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const { pinned, disabled, togglePin } = useChatPinned(chat);

  const activeChatSide = useSelector(activeChatSideSelector);
  const isChatOngoing = activeChatSide === ChatSideType.ON_HOLD;

  const hasPinnedIndicator =
    (isChatOngoing && isHovered && !disabled) || pinned;

  if (!hasPinnedIndicator) return null;

  return (
    <Tooltip
      title={
        pinned
          ? formatMessage({ id: 'Chat.unpin' })
          : formatMessage({ id: 'Chat.pin' })
      }
    >
      <IconWrapper
        fontSize={13}
        style={{
          marginTop: -2,
          cursor: 'pointer',
          pointerEvents: disabled ? 'none' : 'all',
        }}
        color={theme.palette.primary.main}
        onClick={() => togglePin(chat?.id)}
      >
        {PinnedIcon}
      </IconWrapper>
    </Tooltip>
  );
};

export default ChatPinnedIndicator;
